<template>
    <div class="MaterialCreateModal">
        <h1>Add Material</h1>

        <p class="errorMessage" v-if="submitError">{{ submitError }}</p>

        <div class="main">
            <MaterialForm
                ref="materialForm"
                v-bind.sync="material"
            />
        </div>

        <div class="actions">
            <Button class="link" @click="handleCancel">Cancel</Button>
            <Button class="primary" @click="handleCreate" :disabled="submitPending">Save</Button>
        </div>
    </div>
</template>

<script>
import MaterialForm from '@/views/company/material/components/MaterialForm';
import materialCreateMixin from '@/mixins/materialCreateMixin';

export default {
    name: 'MaterialCreateModal',

    mixins: [materialCreateMixin],

    components: { MaterialForm },

    props: {
        onMaterialCreated: { type: Function, required: true },
    },

    mounted() {
        this.$analytics.trackModalView(this.$options.name);
    },

    methods: {
        async handleCreate() {
            this.$analytics.trackButtonClick(this.$options.name, 'save', {
                model_type: 'material',
                model_action: 'create',
            });

            const newMaterial = await this.createMaterial();
            if (newMaterial) {
                this.onMaterialCreated(newMaterial);
                this.$emit('close');
            }
        },

        handleCancel() {
            this.$analytics.trackButtonClick(this.$options.name, 'cancel', {
                model_type: 'material',
                model_action: 'create_cancel',
            });

            this.$emit('close');
        },
    },
}
</script>

<style lang="scss" scoped>
@import 'globals.scss';

.MaterialCreateModal {
    @extend %modal;

    .main {
        max-height: 60vh;
        overflow-y: auto;
        margin: 1rem 0;
    }

    .actions {
        display: flex;
        justify-content: flex-end;
        gap: 0.5rem;
    }

    .errorMessage {
        margin: 1rem 0;
        color: $red-color;
        text-align: center;
    }
}
</style>